/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import LazyLoadLeft from 'bundles/grading/components/staff-graded-assignments/top-bar/LazyLoadLeft';
import LazyLoadRight from 'bundles/grading/components/staff-graded-assignments/top-bar/LazyLoadRight';
import LeftControls from 'bundles/grading/components/staff-graded-assignments/top-bar/LeftControls';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import RightControls from 'bundles/grading/components/staff-graded-assignments/top-bar/RightControls';

const styles = {
  container: () => css`
    width: 100%;
    display: flex;
    align-items: center;
  `,
};

// Component for Top Bar sub components for SGA
const SGATopBar = () => {
  const { submissionData, isPrivateSession } = useContext(SGAPageContext);

  if (submissionData.error) {
    return null;
  }

  let Left;
  let Right;

  if (submissionData.loading) {
    Left = <LazyLoadLeft />;
  } else if (submissionData.error) {
    Left = null;
  } else {
    Left = <LeftControls />;
  }

  if (submissionData.loading) {
    Right = <LazyLoadRight />;
  } else if (submissionData.error) {
    Right = null;
  } else {
    Right = <RightControls showMoreActions={isPrivateSession} />;
  }

  return (
    <div css={styles.container} data-testid="grading-topbar">
      {Left}
      {Right}
    </div>
  );
};

export default SGATopBar;
